import { IMG } from "@/lib/images";

// Language-independent structural data (text lives in i18n/dict.js)
export const LANGS = ["FR", "IT", "EN"];

export const NAV = [
  { key: "home", to: "/" },
  { key: "studio", to: "/studio" },
  { key: "services", to: "/services" },
  { key: "portfolio", to: "/portfolio" },
  { key: "journal", to: "/journal" },
  { key: "contact", to: "/contact" },
];

export const UNIVERSE_META = [
  { key: "interior", image: IMG.interior, to: "/services" },
  { key: "wedding", image: IMG.wedding, to: "/mariages" },
  { key: "event", image: IMG.event, to: "/evenementiel" },
];

export const PROJECTS = [
  { slug: "demande-mariage-paris", name: "Demande en mariage — Paris", location: "Paris, France", year: "2022", image: IMG.proposalMain, gallery: [IMG.proposalMain, IMG.proposalRoom, IMG.proposalBouquet, IMG.proposalBouquet2] },
  { slug: "home-staging-legnano", name: "Home Staging — Legnano", location: "Legnano (Milano), Italie", year: "2025", image: IMG.legKitchen, gallery: [IMG.legKitchen, IMG.legLiving, IMG.legDining, IMG.a2Living, IMG.a2BedroomGreen, IMG.a2BedroomWhite, IMG.a2Bathroom, IMG.a3Living, IMG.a3Lounge, IMG.a3Kitchen, IMG.legBedroom, IMG.legOffice] },
  { slug: "mariage-rueil-malmaison", name: "Mariage — Relais de Saint-Cucufa", location: "Rueil-Malmaison, France", year: "2025", image: IMG.weddingHero, gallery: [IMG.weddingHero, IMG.wedding1, IMG.wedding2, IMG.wedding3, IMG.wedding4] },
  { slug: "balcon-saint-cloud", name: "Balcon — Saint-Cloud", location: "Saint-Cloud, France", year: "2025", image: IMG.balconAfter, beforeAfter: { before: IMG.balconBefore, after: IMG.balconAfter }, gallery: [] },
];

export const TESTI_IMG = [IMG.legKitchen, IMG.weddingHero, IMG.balconAfter];
export const TESTI_META = [
  { author: "Vente sur plan", place: "Legnano (Milano)" },
  { author: "Les mariés", place: "Rueil-Malmaison" },
  { author: "Propriétaire", place: "Saint-Cloud" },
];
